import useInView from "./hooks/useInView";
import './Media.scss';


const Tour = () => {
    const [ref, isVisible] = useInView();
    return (
        <div
            ref={ref}
            className={`media-container ${isVisible ? "fade-in" : ""}`}>
            <div className='media-header'>
                <div className='media-hacienda-logo'>
                    <img src="media.webp" alt="titre media" />
                </div>
                <div className="media-video-container">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/iVFNPGuebr4?si=-tBn9VcGukrWWWhc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    );
};

export default Tour;